export const mailTemplates: TableModule = {
    name: "mailTemplates",
    route: "spa.basedata.mailTemplates",
    defaultOrder: {
        column: "type",
        direction: "asc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true,
        }, {
            name: "type",
            sortable: true,
        }, {
            name: "organisation",
            breakpoint: "lg"
        }, {
            name: "subject_de",
            sortable: true,
            breakpoint: "md"
        }, {
            name: "content_de",
            breakpoint: "xl"
        },
    ],
    filters: [
        {
            name: "organisation",
            column: "id",
            relation: "organisation",
            type: "searchSelect",
            apiRoute: 'spa.settings.organisations.index',
        }
    ],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "mailTemplates"]
        }
    ]
}